var settings = {
  WEBSITE_NAME : 'Direct Docs',
  
}

export default settings;
